import clsx from 'clsx';
import { ReactNode, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { CheckmarkSVG } from 'components/icons/Checkmark';

import { LocaleContext } from './Layout';

export const UnorderedList = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <ul className={twMerge(clsx('flex list-disc flex-col gap-16 md:gap-20', className))}>{children}</ul>;
};

export const CheckListItem = ({
  children,
  className,
  listBulletIcon,
  noCheckmarkList,
}: {
  children: ReactNode;
  className?: string;
  listBulletIcon?: JSX.Element;
  noCheckmarkList?: boolean;
}) => {
  const locale = useContext(LocaleContext);
  return (
    <li
      className={twMerge(
        clsx(
          'text-md md:text-lg',
          !noCheckmarkList && 'flex list-none gap-12 [&_ul_svg]:hidden',
          noCheckmarkList && 'list-inside',
          className,
        ),
      )}
    >
      {noCheckmarkList ? (
        children
      ) : (
        <>
          {listBulletIcon ?? <CheckmarkSVG className="max-h-28 min-h-28 min-w-28 max-w-28 text-primary-200" />}
          <span className="self-center text-left">{children}</span>
        </>
      )}
    </li>
  );
};

type Props = {
  className?: string;
  itemClassName?: string;
  list: string[];
};

export const CheckList = ({ className, itemClassName, list }: Props) => {
  return (
    <UnorderedList className={className}>
      {list.map((text, index) => (
        <CheckListItem key={index} className={itemClassName}>
          {text}
        </CheckListItem>
      ))}
    </UnorderedList>
  );
};
